export default "__VITE_ASSET__8baed292__"